import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { makeStyles, withStyles } from '@material-ui/core/styles'
import Paper from '@material-ui/core/Paper'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import Divider from '@material-ui/core/Divider'
import IconButton from '@material-ui/core/IconButton'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemAvatar from '@material-ui/core/ListItemAvatar'
import QuestionAnswerIcon from '@material-ui/icons/QuestionAnswer'
import Avatar from '@material-ui/core/Avatar'
import Link from '@material-ui/core/Link'
import Tooltip from '@material-ui/core/Tooltip'
import Badge from '@material-ui/core/Badge';
import ListItemText from '@material-ui/core/ListItemText'
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction'
import ReplyIcon from '@material-ui/icons/Reply'
import TextField from '@material-ui/core/TextField'
import CircularProgress from '@material-ui/core/CircularProgress'
import CancelIcon from '@material-ui/icons/Cancel'
import AddCommentIcon from '@material-ui/icons/AddComment'
import SmsIcon from '@material-ui/icons/Sms'
import Button from '@material-ui/core/Button'
import InfiniteScroll from "react-infinite-scroll-component";
import { showSnackBar } from '../../store/AlertMessages/actionCreator'
import AlertMessages from '../Common/AlertMessages'
import Header from './header'
import TextEditor from '../Common/TextEditor'
import { courseDetailsFetch } from '../../store/AddingCourse/actionCreator'
import { fetchResponses, fetchDiscussion, respondedStudentsList, fetchSubReplies, postReply, pinDiscussion, postCommentForResponse, fetchStudentResponses, submitGrade, updateGrade, fetchPinnedResponses } from '../../store/Discussions/actionCreator'
import { ERROR_FETCHING_DISCUSSION_RESPONSE, ERROR_PIN_DISCUSSION, ERROR_UNPIN_DISCUSSION, ERROR_FETCHING_PINNED_RESPONSE, ERROR_UPDATE_DISCUSSION_GRADE, ERROR_FETCH_COURSE_DETAILS, ERROR_SUBMIT_DISCUSSION_GRADE, ERROR_FETCHING_SUBMITTED_USERS_LIST, ERROR_FETCHING_DISCUSSION, ERROR_FETCHING_COMMENTS, ERROR_POST_REPLY, ERROR_FETCHING_STUDENT_RESPONSES, ERROR_POST_COMMENT } from '../Common/Constants/errorMessages';
import { SUCCESS_POST_REPLY, SUCCESS_SUBMIT_DISCUSSION_GRADE, SUCCESS_PIN_DISCUSSION, SUCCESS_UNPIN_DISCUSSION, SUCCESS_UPDATE_DISCUSSION_GRADE, SUCCESS_POST_COMMENT } from '../Common/Constants/successMessages'
import { style } from '../../Styles/theme'
import { convertUTCDatewithTime, convertUTCTimeZone } from '../../Helpers/basic'
import SubRepliesLoader from '../Common/skeletonLoaders/subRepliesLoader'
import StudentListLoader from '../Common/skeletonLoaders/studentListLoader'
import DiscussionLoader from '../Common/skeletonLoaders/discussionLoader'
import ResponsesLoader from '../Common/skeletonLoaders/discussionReponsesLoader'
import GradeViewLoader from '../Common/skeletonLoaders/gradeViewLoader'
import pinIcon from '../../static/pinIcon.png'
import unPinIcon from '../../static/unPinIcon.png'
import responseIcon from '../../static/responseIcon.png'

import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import DescriptionIcon from '@material-ui/icons/Description';
import PictureInPictureIcon from '@material-ui/icons/PictureInPicture';
import { bytesToSize } from '../../Helpers/basic';
import { apiConfig } from '../../Configs/apiConfig'


const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
    marginTop: 65
  },
  topButtonNav: {
    backgroundColor: '#f5f5f5',
    textAlign: 'left'
  },
  button: {
    textTransform: 'none',
    flexGrow: 1,
    marginTop: '10px'
  },
  breadCrumbcontainer: {
    padding: '15px',
    marginLeft: '10px',
    justifyContent: "center",
    marginTop: '5px'
  },
  topic: {
    width: '100%',
    margin: '3rem 3rem 1rem 3rem',
    maxWidth: '70rem',
    backgroundColor: theme.palette.background.paper,
  },
  inline: {
    display: 'inline',
  },
  paper: {
    padding: theme.spacing(2),
    [theme.breakpoints.up(600 + theme.spacing(3) * 2)]: {
      width: 'auto',
      paddingRight: '20px',
      marginLeft: '-38px',
      marginRight: 'auto',
    },
    marginTop: '20px'
  },
  commentsWrapper: {
    padding: theme.spacing(2),
    [theme.breakpoints.up(600 + theme.spacing(3) * 2)]: {
      width: 'auto',
      paddingLeft: '20px',
      paddingRight: '20px',
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  container: {
    display: 'flex',
    justifyContent: 'center'
  },
  containerWrapper: {
    display: 'flex',
    paddingLeft: '20px'
  },
  title: {
    fontSize: '19px',
    fontWeight: '500',
    color: style.fontColour._blue,
    textAlign: 'left',
    lineBreak: 'anywhere'
  },
  discissionTitle: {
    fontSize: '19px',
    fontWeight: '500',
    color: style.fontColour._blue,
    textAlign: 'center',
    lineBreak: 'anywhere'
  },
  discussionDateWrpper: {
    padding: '0.2rem',
    fontSize: style.fontSize._smallDesc,
    color: style.fontColour._naviBlue,
    textAlign: 'center',
    lineBreak: 'anywhere'
  },
  itemInfo: {
    padding: '0.2rem',
    fontSize: style.fontSize._smallDesc,
    color: style.fontColour._naviBlue,
    textAlign: 'left',
    lineBreak: 'anywhere'
  },
  repliesWrapper: {
    fontSize: '15px',
    marginBottom: '10px',
    color: style.fontColour._blue,
  },
  gradeitemInfo: {
    padding: '0.2rem',
    fontSize: style.fontSize._smallDesc,
    color: style.fontColour._naviBlue,
    textAlign: 'center'
  },
  descWrapper: {
    textAlign: 'left',
    lineBreak: 'anywhere'
  },
  avatarComments: {
    backgroundColor: '#6cb5f9'
  },
  avatarReplies: {
    backgroundColor: style.fontColour._naviBlue,
  },
  titleReplies: {
    fontSize: '19px',
    fontWeight: '500',
    color: style.fontColour._naviBlue,
    textAlign: 'left'
  },
  BtnWrapper: {
    marginTop: '10px',
    float: 'right'
  },
  replyIcon: {
    fontSize: '20px',
    paddingRight: '2px',
  },
  UserListWrapper: {
    height: '500px',
    overflow: 'auto',
    border: '18px',
    width: '83%',
    boxShadow: '1px 2px 3px 1px #ccc',
    borderRadius: '5px',
    marginTop: '20px'
  },
  postBtnWrap: {
    marginTop: '10px',
    marginBottom: '10px',
    marginLeft: '20px',
    borderRadius: '5px',
    border: '1px solid #999',
    padding: '5px',
  },
  countIcon: {
    color: style.fontColour._blue,
    fontSize: '20px',
    marginTop: '10px',
  },
  gradeWrapper: {
    marginTop: '20px',
    paddingLeft: '10px',
    paddingRight: '10px',
  },
  gradeTitle: {
    fontSize: '19px',
    marginTop: '20px',
    fontWeight: '500',
    color: style.fontColour._blue,
    textAlign: 'center'
  },
  infoBlock: {
    fontSize: '1rem',
    marginTop: '5px',
    marginBottom: '5px',
    textAlign: 'left'
  },
  closeGradeWrapper: {
    marginTop: '10px',
    marginBottom: '10px',
    float: 'right',
    marginRight: '1px',
    marginLeft: '20px',
    borderRadius: '5px',
    border: '1px solid #999',
    padding: '5px'
  },
  iconWrapper: {
    color: style.fontColour._blue,
    fontSize: "1.5rem",
  },
  errorMsg: {
    color: 'red',
    marginBottom: '-10px'
  },
  uploadedFileWrapper: {
    textDecoration: 'none',
    marginLeft: '10px',
    border: '2px solid #ccc',
  },
  uploadLabel: {
    marginTop: '5px'
  },
  uploadIcon: {
    marginTop: '-3px',
    color: style.fontColour._blue,
    width: 30,
    height: 30,
    verticalAlign: 'bottom',
    cursor: 'pointer'
  },
  uploadedVideo: {
    width: 62,
    marginLeft: 20,
    color: 'blue',
    cursor: 'pointer'
  },
}))

const StyledBadge = withStyles((theme) => ({
  badge: {
    top: 11,
    border: `3px solid ${theme.palette.background.paper}`,
    padding: '4px 4px',
  },
}))(Badge);

function DiscussionReport(props) {
  const classes = useStyles()
  const [courseDetails, setCourseDetails] = React.useState({})
  const [discussionData, setDiscussionData] = React.useState({})
  const [discussionLoader, setDiscussionLoader] = React.useState(false)
  const [respondedStudentList, setRespondedStudentList] = React.useState([])
  const [studentListLoader, setStudentListLoader] = React.useState(false)
  const [openGiveGradeView, setOpenGiveGradeView] = React.useState(false)
  const [studentResponses, setStudentResponses] = React.useState({})
  const [gradeViewLoader, setGradeViewLoader] = React.useState(false)
  const [openPostResponseFiled, setOpenPostResponseField] = React.useState(false)
  const [postResponse, setPostResponse] = React.useState('')
  const defaultPoints = studentResponses && studentResponses.user_score !== null ? studentResponses.user_score : null
  const [studentGrade, setStudentGrade] = React.useState(defaultPoints)
  const [gradeBtnLoader, setGradeBtnLoader] = React.useState(false)
  const [postBtnLoader, setPostBtnLoader] = React.useState(false)
  const [pinnedResponseData, setPinnedResponseData] = React.useState([])
  const [responsesLoader, setResponsesLoader] = React.useState(false)
  const [responseData, setResponseData] = React.useState([])
  const rowsPerPage = 10
  const [hasMoreData, setHasMoreData] = React.useState(true)
  const [pageNum, setPageNum] = React.useState(0)
  const [responseId, setResponseId] = React.useState('')
  const [postReplyData, setpostReplyData] = React.useState('')
  const [subReplies, setSubReplies] = React.useState([])
  const [subRepliesLoader, setSubRepliesLoader] = React.useState(false)
  const [viewCommentsIndex, setViewCommentsIndex] = React.useState('')
  const [loadMoreBtnPrgs, setLoadMoreBtnPrgs] = React.useState(false)
  const [pageNumForSubReplies, setPageNumForSubReplies] = React.useState(0)
  const [validationDiscussionError, setValidationDiscussionError] = React.useState({
    error: false,
    errorMessage: ''
  })
  const [gradeValidation, setGradeValidation] = React.useState({
    error: false,
    errorMessage: ''
  })
  const [postReplyValidationError, setPostReplyValidation] = React.useState({
    error: false,
    errorMessage: ''
  })

  //FOR ATTACHEMENT UPLOAD
  const [attachmentFileDetails, setAttachmentFileDetails] = React.useState({});
  const [uploadedAttachmentPreview, setUploadedAttachmentPreview] = React.useState('')


  //COURSE DETAILS FETCH CALLBACKS
  const courseSuccessCB = res => {
    setCourseDetails(res.results)
  }
  const courseFailureCB = error => {
    setCourseDetails({})
    props.showSnackBar(
      {
        state: false,
        message: ERROR_FETCH_COURSE_DETAILS,
        type: 'error'
      }
    )
  }

  //DISCUSSION DETAILS FETCH CALLBACKS
  const discussionSuccessCB = res => {
    setDiscussionLoader(false)
    setDiscussionData(res.results)
  }
  const discussionFailureCB = error => {
    setDiscussionLoader(false)
    setDiscussionData({})
    props.showSnackBar(
      {
        state: false,
        message: ERROR_FETCHING_DISCUSSION,
        type: 'error'
      }
    )
  }
  const discussionDetailsFetch = () => {
    setDiscussionLoader(true)
    const payload = {
      discussion_id: props.match.params.discussionId
    }
    fetchDiscussion(payload, discussionSuccessCB, discussionFailureCB)
  }

  //RESPONDED STUDENTS FETCH CALLBACKS
  const successStudentListCB = res => {
    setStudentListLoader(false)
    setRespondedStudentList(res.results)
  }
  const failureStudentsListCB = error => {
    setStudentListLoader(false)
    setRespondedStudentList([])
    props.showSnackBar(
      {
        state: false,
        message: ERROR_FETCHING_SUBMITTED_USERS_LIST,
        type: 'error'
      }
    )
  }
  const fetchRespondedStudentList = () => {
    setStudentListLoader(true)
    const payLoad = {
      forum_id: props.match.params.discussionId
    }
    respondedStudentsList(payLoad, successStudentListCB, failureStudentsListCB)
  }

  const successPinnedResponse = res => {
    setPinnedResponseData(res.results)
  }
  const failurePinnedResponse = error => {
    setPinnedResponseData([])
    props.showSnackBar(
      {
        state: false,
        message: ERROR_FETCHING_PINNED_RESPONSE,
        type: 'error'
      }
    )
  }
  const pinnedResponsesFetch = () => {
    fetchPinnedResponses({
      forum_id: props.match.params.discussionId,
    }, successPinnedResponse, failurePinnedResponse)
  }

  //RESPONSES CALLBACKS
  const responseSuccess = res => {
    setResponsesLoader(false)
    setResponseData(res.results)
  }
  const responseFailure = error => {
    setResponsesLoader(false)
    setResponseData([])
    props.showSnackBar(
      {
        state: false,
        message: ERROR_FETCHING_DISCUSSION_RESPONSE,
        type: 'error'
      }
    )
  }
  const discussionReportFetch = (pageNum) => {
    setResponsesLoader(true)
    fetchResponses({
      forum_id: props.match.params.discussionId,
      number: rowsPerPage,
      offset: pageNum * rowsPerPage,
    }, responseSuccess, responseFailure)
  }

  useEffect(() => {
    courseDetailsFetch({
      id: props.match.params.courseId
    }, courseSuccessCB, courseFailureCB)
    discussionReportFetch(0)
    discussionDetailsFetch()
    fetchRespondedStudentList()
    pinnedResponsesFetch()
    const defaultPoints = studentResponses && studentResponses.user_score !== null ? studentResponses.user_score : null
    setStudentGrade(defaultPoints)
  }, [studentResponses])

  const dateFormat = (due_days) => {
    return (convertUTCTimeZone(due_days))
  }
  function createMarkup(data) {
    return {
      __html: data
    };
  }
  const onChangeEditorContent = data => {
    setPostResponse(data)
  }
  const dateTimeFormat = (due_days) => {
    return (convertUTCDatewithTime(due_days))
  }

  //ONSTUDENT NAME CLICK FUNCTION
  const successFetchStudentResponse = res => {
    closeGradeView()
    setGradeViewLoader(false)
    setStudentResponses(res.results)
    setOpenGiveGradeView(true)
  }
  const failureFetchStudentResponse = error => {
    setGradeViewLoader(false)
    setOpenGiveGradeView(false)
    setStudentResponses({})
    props.showSnackBar(
      {
        state: false,
        message: ERROR_FETCHING_STUDENT_RESPONSES,
        type: 'error'
      }
    )
  }
  const onStudentNameClick = (userId) => {
    setGradeValidation({
      error: false,
      errorMessage: ''
    })
    setGradeViewLoader(true)
    const payload = {
      forum_id: Number(props.match.params.discussionId),
      user_id: userId,
    }
    fetchStudentResponses(payload, successFetchStudentResponse, failureFetchStudentResponse)
  }

  const onClickPostResponse = () => {
    setValidationDiscussionError({
      error: false,
      errorMessage: ''
    })
    setOpenPostResponseField(true)
  }
  const closePostResponseField = () => {
    setValidationDiscussionError({
      error: false,
      errorMessage: ''
    })
    setOpenPostResponseField(false)
    setPostResponse('')
    setAttachmentFileDetails({})
    setUploadedAttachmentPreview('')
  }

  const successPostResponse = res => {
    setPostBtnLoader(false)
    setValidationDiscussionError({
      error: false,
      errorMessage: ''
    })
    props.showSnackBar(
      {
        state: true,
        message: SUCCESS_POST_REPLY,
        type: 'success'
      }
    )
    closePostResponseField()
    discussionDetailsFetch()
    fetchRespondedStudentList()
    discussionReportFetch(0)
    setPostResponse('')
    setHasMoreData(true)
    setPageNum(0)
    setAttachmentFileDetails({})
    setUploadedAttachmentPreview('')

  }
  const failurePostResponse = error => {
    setPostBtnLoader(false)
    setValidationDiscussionError({
      error: false,
      errorMessage: ''
    })
    props.showSnackBar(
      {
        state: false,
        message: ERROR_POST_REPLY,
        type: 'error'
      }
    )
  }

  const onTriggerSubmmitResponse = (event) => {
    if (postResponse === '') {
      setValidationDiscussionError({
        error: true,
        errorMessage: 'Please add response and then post!'
      })
    } else if (attachmentFileDetails.fileError) {
      setValidationDiscussionError({
        error: true,
        errorMessage: 'Please add supported file only!'
      })
    }
    else {
      setPostBtnLoader(true)
      setValidationDiscussionError({
        error: false,
        errorMessage: ''
      })
      const payload = {
        forum_id: Number(props.match.params.discussionId),
        reply_text: postResponse ? postResponse : ''
      }
      // let formData = new FormData()
      // formData.append('forum_id', Number(props.match.params.discussionId))
      // formData.append('reply_text', postResponse ? postResponse : '')
      // formData.append('attachment', attachmentFileDetails.file ? attachmentFileDetails.file : null)
      postReply(payload, successPostResponse, failurePostResponse)
    }
  }
  const closeGradeView = () => {
    setOpenGiveGradeView(false)
    setStudentResponses({})
    setStudentGrade('')
    setGradeValidation({
      error: false,
      errorMessage: ''
    })
  }

  //FOR GIVING GRADE FUNCTIONS START HERE
  const handleChangeGrade = (event) => {
    setStudentGrade(event.target.value)
  }
  const submitGradeSuccessCB = res => {
    setGradeBtnLoader(false)
    setGradeValidation({
      error: false,
      errorMessage: ''
    })
    props.showSnackBar(
      {
        state: true,
        message: SUCCESS_SUBMIT_DISCUSSION_GRADE,
        type: 'success'
      }
    )
    fetchRespondedStudentList()
    closeGradeView()
  }
  const submitGradeFailureCB = error => {
    setGradeBtnLoader(false)
    setGradeValidation({
      error: false,
      errorMessage: ''
    })
    props.showSnackBar(
      {
        state: false,
        message: ERROR_SUBMIT_DISCUSSION_GRADE,
        type: 'error'
      }
    )
  }
  const updateGradeSuccsessCB = res => {
    setGradeBtnLoader(false)
    setGradeValidation({
      error: false,
      errorMessage: ''
    })
    props.showSnackBar(
      {
        state: true,
        message: SUCCESS_UPDATE_DISCUSSION_GRADE,
        type: 'success'
      }
    )
    fetchRespondedStudentList()
    closeGradeView()
  }
  const updateGradeFailureCB = error => {
    setGradeBtnLoader(false)
    setGradeValidation({
      error: false,
      errorMessage: ''
    })
    props.showSnackBar(
      {
        state: false,
        message: ERROR_UPDATE_DISCUSSION_GRADE,
        type: 'error'
      }
    )
  }
  const submitStudenGrade = event => {
    event.preventDefault()
    if (studentGrade === null || studentGrade === '') {
      setGradeValidation({
        error: true,
        errorMessage: 'Please add grade points!'
      })
    }
    else if (studentGrade > (discussionData && discussionData.points)) {
      setGradeValidation({
        error: true,
        errorMessage: `grade should be less than ${discussionData.points} pts`
      })
    }
    else if (isNaN(studentGrade) || studentGrade < 0 || studentGrade > 100) {
      setGradeValidation({
        error: true,
        errorMessage: 'Please give valid points'
      })
    }
    else {
      setGradeBtnLoader(true)
      if (studentResponses.user_score !== null) {
        const payload = {
          forum_id: Number(props.match.params.discussionId),
          grade_id: studentResponses.grade_id,
          score: Number(studentGrade),
        }
        updateGrade(payload, updateGradeSuccsessCB, updateGradeFailureCB)
      }
      else {
        const payload = {
          forum_id: Number(props.match.params.discussionId),
          user_id: studentResponses.user_id,
          score: Number(studentGrade),
        }
        submitGrade(payload, submitGradeSuccessCB, submitGradeFailureCB)
      }
    }
  }

  //PINNED CALLBACKS
  const pinSuccessCallBack = res => {
    props.showSnackBar(
      {
        state: true,
        message: SUCCESS_PIN_DISCUSSION,
        type: 'success'
      }
    )
    pinnedResponsesFetch()
    discussionReportFetch(0)
  }

  const pinFailureCallBack = error => {
    props.showSnackBar(
      {
        state: false,
        message: ERROR_PIN_DISCUSSION,
        type: 'error'
      }
    )
  }
  const unPinSuccessCallBack = res => {
    props.showSnackBar(
      {
        state: true,
        message: SUCCESS_UNPIN_DISCUSSION,
        type: 'success'
      }
    )
    pinnedResponsesFetch()
    discussionReportFetch(0)
  }
  const unPinFailureCallBack = error => {
    props.showSnackBar(
      {
        state: false,
        message: ERROR_UNPIN_DISCUSSION,
        type: 'error'
      }
    )
  }
  const triggerPinResponse = (data, type) => {
    if (type === 'pin') {
      const payload = {
        reply_id: data.id ? data.id : null,
        pinned: true
      }
      pinDiscussion(payload, pinSuccessCallBack, pinFailureCallBack)
    }
    else if (type === 'unPin') {
      const payload = {
        reply_id: data.id ? data.id : null,
        pinned: false
      }
      pinDiscussion(payload, unPinSuccessCallBack, unPinFailureCallBack)
    }
  }
  const responseScrollSuccess = res => {
    if (res && res.results.length) {
      let newData = [...responseData]
      {
        res.results.map((data, index) => {
          newData.push(data)
        })
      }
      setResponseData(newData)
    }
  }
  const responseScrollFailure = error => {
    props.showSnackBar(
      {
        state: false,
        message: ERROR_FETCHING_DISCUSSION_RESPONSE,
        type: 'error'
      }
    )
  }
  const fetchMoreData = () => {
    if (responseData.length >= discussionData.reply_count) {
      setHasMoreData(false)
      return
    }
    setPageNum(pageNum + 10)
    fetchResponses({
      forum_id: props.match.params.discussionId,
      number: rowsPerPage,
      offset: pageNum + rowsPerPage,
    }, responseScrollSuccess, responseScrollFailure)
  };

  const onReplyTrigger = (dataId) => {
    setPageNum(0)
    setpostReplyData('')
    setPostReplyValidation({
      error: false,
      errorMessage: ''
    })
    setResponseId(dataId)
    closePostResponseField()
  }
  const handleChangeReply = (event) => {
    setPostReplyValidation({
      error: false,
      errorMessage: ''
    })
    setpostReplyData(event.target.value)
  }
  const successPostComment = res => {
    setPostReplyValidation({
      error: false,
      errorMessage: ''
    })
    setPostBtnLoader(false)
    props.showSnackBar(
      {
        state: true,
        message: SUCCESS_POST_COMMENT,
        type: 'success'
      }
    )
    setResponseId(null)
    setViewCommentsIndex(null)
    discussionReportFetch(0)
    setHasMoreData(true)
    setPageNum(0)
  }
  const failurePostComment = error => {
    setPostBtnLoader(false)
    setPostReplyValidation({
      error: false,
      errorMessage: ''
    })
    props.showSnackBar(
      {
        state: false,
        message: ERROR_POST_COMMENT,
        type: 'error'
      }
    )
  }
  const triggerPostComment = (data) => {
    if (postReplyData === '') {
      setPostReplyValidation({
        error: true,
        errorMessage: 'Please Add Reply And Then Post!'
      })
    } else {
      setPostReplyValidation({
        error: false,
        errorMessage: ''
      })
      setPostBtnLoader(true)
      const payload = {
        reply_id: Number(data.id),
        comment_text: postReplyData ? postReplyData : ''
      }
      postCommentForResponse(payload, successPostComment, failurePostComment)
    }
  }

  //ONCLICK VIEW MORE COMMENTS
  const successSubReplies = res => {
    setSubRepliesLoader(false)
    setSubReplies(res.results)
  }
  const failureSubReplies = error => {
    setSubRepliesLoader(false)
    setSubReplies([])
    props.showSnackBar(
      {
        state: false,
        message: ERROR_FETCHING_COMMENTS,
        type: 'error'
      }
    )
  }
  const onViewCommentsClick = (dataId, pageNumForSubReplies) => {
    setPageNumForSubReplies(0)
    setSubRepliesLoader(true)
    setViewCommentsIndex(dataId)
    const payload = {
      number: rowsPerPage,
      offset: pageNumForSubReplies * rowsPerPage,
      reply_id: dataId
    }
    fetchSubReplies(payload, successSubReplies, failureSubReplies)
  }

  const subRepliesScrollSuccess = res => {
    setLoadMoreBtnPrgs(false)
    if (res && res.results.length) {
      let newData = [...subReplies]
      {
        res.results.map((data, index) => {
          newData.push(data)
        })
      }
      setSubReplies(newData)
    }
  }
  const subRepliesScrollFailure = error => {
    setLoadMoreBtnPrgs(false)
    props.showSnackBar(
      {
        state: false,
        message: ERROR_FETCHING_COMMENTS,
        type: 'error'
      }
    )
  }
  const fetchMoreSubReplies = (dataId) => {
    setLoadMoreBtnPrgs(true)
    setPageNumForSubReplies(pageNumForSubReplies + 10)
    fetchSubReplies({
      reply_id: dataId ? dataId : null,
      number: rowsPerPage,
      offset: pageNumForSubReplies + rowsPerPage
    }, subRepliesScrollSuccess, subRepliesScrollFailure)
  }

  //FOR FILE UPLOAD on
  const onFileToUploadClick = type => {
    document.getElementById(type).click()
  }
  const validatedFile = type => {
    const selectedFile = document.getElementById(type).files
    let fileDetails = {
      fileError: false,
      fileErrorErrorMessage: ''
    }
    if (!selectedFile.length || selectedFile.length > 1) {
      fileDetails = {
        fileError: false,
        fileErrorErrorMessage: ''
      }
    } else {
      const file = selectedFile[0]
      if (type === 'attachmentfile' && file.size > apiConfig.assignment.acceptedAttachmentFileSize) {
        fileDetails = {
          fileError: true,
          fileErrorErrorMessage: 'File size should be less than 10MB'
        }
      } else {
        const fileFormats = () => {
          if (type === 'attachmentfile') {
            return apiConfig.assignment.acceptedAssignmentFileFormats
          }
        }
        const allowedExtensions = fileFormats()
        const currentExtension = file.name.split('.')[1].toLowerCase()
        if (allowedExtensions.indexOf(currentExtension) === -1) {
          fileDetails = {
            fileError: true,
            fileErrorErrorMessage: 'Invalid File Format'
          }
        } else {
          fileDetails = {
            fileError: false,
            fileErrorErrorMessage: '',
            name: file.name,
            size: bytesToSize(file.size),
            type: file.type,
            file: file
          }
        }
      }
    }
    return fileDetails
  }
  const onAttachmentUpload = event => {
    setValidationDiscussionError({
      error: false,
      errorMessage: ''
    })
    const attachment = validatedFile('attachmentfile')
    setAttachmentFileDetails(attachment)
    setUploadedAttachmentPreview(event.target.files[0] ? URL.createObjectURL(event.target.files[0]) : null)
  }


  const renderSubReplies = (data) => {
    let btnValid = false
    if (loadMoreBtnPrgs) {
      btnValid = true
    }
    else if (subReplies.length >= data.comment_count) {
      btnValid = true
    }
    return (
      <List>
        {subReplies && subReplies.length ? (
          <React.Fragment>
            {subReplies.map((item, index) => (
              <React.Fragment key={index}>
                <ListItem>
                  <ListItemAvatar>
                    <Avatar className={classes.avatarReplies}>
                      {item.first_name && item.first_name.substring(0, 1)}
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText className={classes.titleReplies} primary={`${item.first_name && item.first_name} ${item.last_name && item.last_name} ${item.role_user && item.role_user.indexOf('Author') >= 0 ? '(Author)' : ''}`} secondary={dateTimeFormat(item.submission_date && item.submission_date)} />
                </ListItem>
                <div style={{ marginLeft: '73px', textAlign: 'initial', lineBreak: 'anywhere' }} dangerouslySetInnerHTML={createMarkup(item.comment_text && item.comment_text)}></div>
                <Divider variant="inset" component="li" aria-hidden="true" />
              </React.Fragment>
            ))}
            {data.comment_count >= 10 ? (
              <React.Fragment>
                {loadMoreBtnPrgs ? (
                  <CircularProgress size={20} style={{ marginBottom: '-9px' }} />
                ) : null}
                <Button disabled={btnValid} style={{ marginTop: '10px', textTransform: 'none', flexGrow: 1, }} variant="outlined" size="small" color="primary" onClick={() => { fetchMoreSubReplies(data.id) }}>
                  Load More Data
                </Button>
              </React.Fragment>
            ) : null}
          </React.Fragment>
        ) : (
          <Typography>No Comments Found</Typography>
        )}
      </List>
    )
  }

  let showPinBtn = false
  if (pinnedResponseData && pinnedResponseData.length === 3) {
    showPinBtn = true
  }
  return (
    <div className={classes.root}>
      <div id="mainH1Tag" tabIndex="-1" className="accessibility">
        <h1>Discussion report view</h1>
      </div>
      <Paper elevation={0} className={classes.topButtonNav}>
        <div className={classes.breadCrumbcontainer}>
          <Header histoy={props.history} match={props.match} courseDetails={courseDetails} discussionData={discussionData} />
        </div>
      </Paper>
      <Grid container className={classes.containerWrapper}>
        <Grid item xs={8} sm={8} md={2} lg={2}>
          <div className={classes.UserListWrapper}>
            {studentListLoader ? (
              <StudentListLoader />
            ) : (
              <React.Fragment>
                <Typography style={{ padding: '0.2rem', fontWeight: '500', color: style.fontColour._naviBlue }}>Responded Users</Typography>
                <List>
                  <Divider aria-hidden="true" />
                  {respondedStudentList && respondedStudentList.length ? (
                    <React.Fragment>
                      {respondedStudentList && respondedStudentList.map((data, index) => (
                        <React.Fragment key={index}>
                          <ListItem style={{ textAlign: 'center', pointer: 'courser' }}>
                            <Link component="button" onClick={() => { onStudentNameClick(data.user_id) }} style={{ color: style.fontColour._blue, textAlign: 'center', textDecoration: 'none', cursor: 'pointer' }}>
                              {data && data.first_name && data.first_name.length > 15 ? (
                                <React.Fragment>
                                  {`${data && data.first_name && data.first_name.substr(0, 10) + '...'}`}
                                </React.Fragment>
                              ) : (
                                `${data && data.first_name && data.first_name} ${data && data.last_name && data.last_name}`
                              )}
                              {discussionData && discussionData.graded_reply === true ? <span style={{ color: style.fontColour._blue, display: 'flex', fontSize: '11px', marginLeft: '50px' }}>{data.user_score !== null ? `points (${data.user_score})` : null}</span> : null}
                            </Link>
                          </ListItem>
                          <Divider aria-hidden="true" />
                        </React.Fragment>
                      ))}
                    </React.Fragment>
                  ) : (
                    <p>No data found</p>
                  )}
                </List>
              </React.Fragment>
            )}
          </div>
        </Grid>
        <Grid item xs={12} sm={12} md={10} lg={10}>
          {!openGiveGradeView ? (
            <React.Fragment>
              {discussionLoader ? (
                <DiscussionLoader />
              ) : (
                <React.Fragment>
                  <Grid container className={classes.paper}>
                    <Grid item md={9} lg={9}>
                      <QuestionAnswerIcon className={classes.iconWrapper} />
                      <div className={classes.discissionTitle}>{discussionData && discussionData.title ? discussionData.title : ''}</div>
                      <div className={classes.discussionDateWrpper}>Start Date: {discussionData && discussionData.start_date ? dateFormat(discussionData && discussionData.start_date) : "NA"} &nbsp;&nbsp; Due Date: {dateFormat(discussionData && discussionData.end_date)} &nbsp;&nbsp; {discussionData && discussionData.graded_reply && discussionData.points ? (`Pts: ${discussionData.points}`) : null} &nbsp;&nbsp;</div>
                      <Typography className={classes.title}>Description</Typography>
                      <div className={classes.descWrapper} dangerouslySetInnerHTML={createMarkup(discussionData && discussionData.description)}></div>
                    </Grid>
                    <Grid item lg={1}>
                      <div id="mainH1Tag" tabIndex="-1" className="accessibility">
                        <p>{`discussion responses count ${discussionData.reply_count}`}</p>
                      </div>
                      <Tooltip title={`${discussionData.reply_count} responses`} aria-hidden="true">
                        <StyledBadge badgeContent={discussionData.reply_count} color='secondary'>
                          <img src={responseIcon} alt="response count" style={{ height: '24px', marginTop: '11px' }} />
                        </StyledBadge>
                      </Tooltip>
                    </Grid>
                    <Grid item lg={2}>
                      <IconButton disabled={postBtnLoader} edge="end" style={{ marginTop: '10px', borderRadius: '5px', border: '1px solid #999', padding: '5px', marginLeft: '5px' }} aria-label="post response to discussion" onClick={() => { onClickPostResponse() }}>
                        <AddCommentIcon className={classes.commentIcon} /> <div style={{ fontSize: '10px' }}>Post a Response</div>
                      </IconButton>
                    </Grid>
                  </Grid>
                </React.Fragment>
              )}
              <Grid item xs={11} sm={11} md={10} lg={10} style={{ paddingLeft: '20px' }}>
                {openPostResponseFiled ? (
                  <form autoComplete="off" onSubmit={evnt => { evnt.preventDefault() }} >
                    <Grid container >
                      <Grid item xs={12} sm={12} md={12} lg={12} style={{ display: 'flex', justifyContent: 'center' }}>
                        {validationDiscussionError.error ? (
                          <div style={{ marginBottom: '20px' }}>
                            <AlertMessages status="error" message={validationDiscussionError.errorMessage} />
                          </div>
                        ) : null}
                      </Grid>
                    </Grid>
                    <TextEditor onChangeEditorContent={onChangeEditorContent} helperText={'Add response here and then post!'} />
                    {/* <div>
                      <Grid item xs={12} sm={12} md={12} lg={12} xl={12} style={{ textAlign: 'left' }}>
                        {attachmentFileDetails.fileError ? (
                          <Typography variant="caption" display="block" gutterBottom className={classes.errorMsg}>
                            {attachmentFileDetails.fileErrorErrorMessage}
                          </Typography>
                        ) : null}
                      </Grid>
                      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <div style={{ display: 'flex', marginTop: '11px' }}>
                          <span className={classes.uploadLabel} aria-hidden="true">
                            Upload Attachment
                          </span>
                          <IconButton style={{ padding: '2px 8px' }} aria-label="upload attachment" onClick={() => { onFileToUploadClick('attachmentfile') }}>
                            <CloudUploadIcon className={classes.uploadIcon} />
                          </IconButton>
                          {attachmentFileDetails.file && attachmentFileDetails.file.name && uploadedAttachmentPreview ? (
                            <a href={uploadedAttachmentPreview} target='_blank' className={classes.uploadedFileWrapper}>
                              {attachmentFileDetails.file.name.length > 25 ? (
                                attachmentFileDetails.file.name.substr(0, 20) + '....'
                              ) :
                                attachmentFileDetails.file.name
                              }
                            </a>
                          ) : null}
                        </div>
                        <div style={{ display: 'flex', marginTop: '5px' }}>
                          <span style={{ color: '#999' }}>Optional, max.size: 10MB, format: pdf, docx, ppt</span>
                        </div>
                      </Grid>
                      <input type="file" accept=".ppt,.pdf,.docx" style={{ display: 'none' }} id="attachmentfile" onChange={onAttachmentUpload} />
                    </div> */}
                    {postBtnLoader ? (
                      <CircularProgress size={20} style={{ marginBottom: '-6px' }} />
                    ) : null}
                    <IconButton disabled={postBtnLoader} edge="end" aria-label="Post response" className={classes.postBtnWrap} onClick={(event) => { onTriggerSubmmitResponse(event) }}>
                      <SmsIcon className={classes.replyIcon} /> <div style={{ fontSize: '10px' }}>Post response</div>
                    </IconButton>
                    <IconButton disabled={postBtnLoader} edge="end" aria-label="Cancel" className={classes.postBtnWrap} onClick={(event) => { closePostResponseField(event) }}>
                      <CancelIcon className={classes.replyIcon} /> <div style={{ fontSize: '10px' }}>Cancel</div>
                    </IconButton>
                  </form>
                ) : null}
              </Grid>
              <Divider style={{ marginLeft: '-38px' }} aria-hidden="true" />
              <Grid item xs={11} sm={11} md={11} lg={11} style={{ marginLeft: '-29px' }}>
                {pinnedResponseData && pinnedResponseData.length ? (
                  <React.Fragment>
                    <div className={classes.commentsWrapper}>
                      <Typography className={classes.title}>Pinned Responses</Typography>
                    </div>
                    <List>
                      {pinnedResponseData && pinnedResponseData.map((data, index) => (
                        <React.Fragment key={index}>
                          <ListItem>
                            <Grid container>
                              <Grid item xs={5} sm={5} md={5} lg={5} xl={5}>
                                <div style={{ display: 'flex' }}>
                                  <ListItemAvatar>
                                    <Avatar className={classes.avatarReplies}>
                                      {data.first_name && data.first_name.substring(0, 1)}
                                    </Avatar>
                                  </ListItemAvatar>
                                  <ListItemText className={classes.titleReplies} primary={`${data.first_name && data.first_name} ${data.last_name && data.last_name}`} secondary={dateTimeFormat(data.submission_date && data.submission_date)} />
                                </div>
                              </Grid>
                              <Grid item xs={4} sm={4} md={4} lg={4} xl={4} style={{ textAlign: 'end' }}>
                                {data && data.attachment_details && data.attachment_details.file_name ? (
                                  <React.Fragment>
                                    {data.attachment_details && data.attachment_details.file_name && data.attachment_details.file_name.split('.')[1] === 'pdf' ? <PictureAsPdfIcon style={{ color: '#2e8eec', marginBottom: '-7px', marginLeft: '10px', marginRight: '-10px' }} /> : data.attachment_details.file_name.split('.')[1] === 'ppt' ? <PictureInPictureIcon style={{ color: '#2e8eec', marginBottom: '-7px', marginLeft: '10px', marginRight: '-10px' }} /> : <DescriptionIcon style={{ color: '#2e8eec', marginBottom: '-7px', marginLeft: '10px', marginRight: '-10px' }} />}
                                    <a href={data.attachment_details && data.attachment_details.file_url && data.attachment_details.file_url} target='_blank' className={classes.uploadedVideo}>
                                      {data.attachment_details && data.attachment_details.file_name && data.attachment_details.file_name.length > 15 ? (
                                        data.attachment_details && data.attachment_details.file_name && data.attachment_details.file_name && data.attachment_details.file_name.substr(0, 15) + '...'
                                      ) :
                                        data.attachment_details && data.attachment_details.file_name && data.attachment_details.file_name && data.attachment_details.file_name
                                      }
                                    </a>
                                  </React.Fragment>
                                ) : null}
                              </Grid>
                              <ListItemSecondaryAction>
                                <Tooltip title="Unpin response">
                                  <IconButton onClick={() => { triggerPinResponse(data, 'unPin') }} >
                                    <img src={unPinIcon} alt="Unpin discussion" style={{ height: '21px' }} aria-hidden="true" />
                                  </IconButton>
                                </Tooltip>
                              </ListItemSecondaryAction>
                            </Grid>
                          </ListItem>
                          <div style={{ marginLeft: '73px', textAlign: 'initial', lineBreak: 'anywhere' }} dangerouslySetInnerHTML={createMarkup(data.reply_text && data.reply_text)}></div>
                          <Divider variant="inset" component="li" aria-hidden="true" />
                        </React.Fragment>
                      ))}
                    </List>
                  </React.Fragment>
                ) : null}
                {responsesLoader ? (
                  <ResponsesLoader />
                ) : (
                  <React.Fragment>
                    <div className={classes.commentsWrapper}>
                      <Typography className={classes.title}>Responses</Typography>
                    </div>
                    {responseData && responseData.length ? (
                      <List>
                        <InfiniteScroll
                          dataLength={responseData.length}
                          next={() => { fetchMoreData() }}
                          hasMore={hasMoreData}
                          loader={<h4>Loading...</h4>}
                          scrollableTarget="scrollableDiv"
                          height={500}
                          endMessage={
                            <p style={{ textAlign: "center" }}>
                              <b>Yay! You have seen it all</b>
                            </p>
                          }
                        >
                          {responseData && responseData.map((data, index) => (
                            <React.Fragment key={index}>
                              <ListItem>
                                <Grid container>
                                  <Grid item xs={5} sm={5} md={5} lg={5} xl={5}>
                                    <div style={{ display: 'flex' }}>
                                      <ListItemAvatar>
                                        <Avatar className={classes.avatarComments} aria-label="user avatar">
                                          {data.first_name && data.first_name.substring(0, 1)}
                                        </Avatar>
                                      </ListItemAvatar>
                                      <ListItemText className={classes.title} primary={`${data.first_name && data.first_name} ${data.last_name && data.last_name} ${data.role_user && data.role_user.indexOf('Author') >= 0 ? '(Author)' : ''}`} secondary={dateTimeFormat(data.submission_date && data.submission_date)} />
                                    </div>
                                  </Grid>
                                  <Grid item xs={4} sm={4} md={4} lg={4} xl={4} style={{ textAlign: 'end' }}>
                                    {data && data.attachment_details && data.attachment_details.file_name ? (
                                      <React.Fragment>
                                        {data.attachment_details && data.attachment_details.file_name && data.attachment_details.file_name.split('.')[1] === 'pdf' ? <PictureAsPdfIcon style={{ color: '#2e8eec', marginBottom: '-7px', marginLeft: '10px', marginRight: '-10px' }} /> : data.attachment_details.file_name.split('.')[1] === 'ppt' ? <PictureInPictureIcon style={{ color: '#2e8eec', marginBottom: '-7px', marginLeft: '10px', marginRight: '-10px' }} /> : <DescriptionIcon style={{ color: '#2e8eec', marginBottom: '-7px', marginLeft: '10px', marginRight: '-10px' }} />}
                                        <a href={data.attachment_details && data.attachment_details.file_url && data.attachment_details.file_url} target='_blank' className={classes.uploadedVideo}>
                                          {data.attachment_details && data.attachment_details.file_name && data.attachment_details.file_name.length > 15 ? (
                                            data.attachment_details && data.attachment_details.file_name && data.attachment_details.file_name && data.attachment_details.file_name.substr(0, 15) + '...'
                                          ) :
                                            data.attachment_details && data.attachment_details.file_name && data.attachment_details.file_name && data.attachment_details.file_name
                                          }
                                        </a>
                                      </React.Fragment>
                                    ) : null}
                                  </Grid>
                                  <Grid item xs={3} sm={3} md={3} lg={3} xl={3}>
                                    <ListItemSecondaryAction>
                                      {pinnedResponseData && pinnedResponseData.length !== 3 ? (
                                        <Tooltip title="Pin response">
                                          <IconButton disabled={showPinBtn} onClick={() => { triggerPinResponse(data, 'pin') }}>
                                            <img src={pinIcon} alt="Pin discussion" style={{ height: '21px' }} aria-hidden="true" />
                                          </IconButton>
                                        </Tooltip>
                                      ) : null}
                                      {discussionData.threaded_reply ? (
                                        <IconButton disabled={postBtnLoader} edge="end" style={{ borderRadius: '5px', border: '1px solid #999', padding: '5px', marginRight: '2px' }} aria-label="reply" onClick={() => { onReplyTrigger(data.id) }}>
                                          <ReplyIcon className={classes.replyIcon} /> <div style={{ fontSize: '10px' }}>Reply</div>
                                        </IconButton>
                                      ) : null}
                                    </ListItemSecondaryAction>
                                  </Grid>
                                </Grid>
                              </ListItem>
                              <div style={{ marginLeft: '73px', textAlign: 'initial', marginRight: '1px', lineBreak: 'anywhere' }} dangerouslySetInnerHTML={createMarkup(data.reply_text && data.reply_text)}></div>
                              {discussionData.threaded_reply && data.has_comments && data.comment_count > 0 && data.id !== viewCommentsIndex ? (
                                <Link component="button" onClick={() => { onViewCommentsClick(data.id, 0) }} style={{ display: 'block', marginLeft: '74px', marginTop: '7px', marginBottom: '8px', fontSize: '0.7rem', color: style.fontColour._blue, textDecoration: 'none', cursor: 'pointer' }}>
                                  {`View ${data.comment_count} more comments`}
                                </Link>
                              ) : (
                                <React.Fragment>
                                  {discussionData.threaded_reply && data.has_comments && data.comment_count > 0 && data.id === viewCommentsIndex ? (
                                    <Link component="button" onClick={() => { setViewCommentsIndex(null) }} style={{ display: 'block', marginLeft: '74px', marginTop: '7px', marginBottom: '8px', fontSize: '0.7rem', color: style.fontColour._blue, textDecoration: 'none', cursor: 'pointer' }}>
                                      hide comments
                                    </Link>
                                  ) : null}
                                </React.Fragment>
                              )}
                              <Grid item xs={8} sm={8} md={8} lg={8} style={{ marginLeft: '60px', marginTop: '20px' }}>
                                {data.id === responseId ? (
                                  <form autoComplete="off" onSubmit={evnt => { evnt.preventDefault() }} >
                                    <Grid container >
                                      <Grid item xs={12} sm={12} md={12} lg={12} style={{ display: 'flex', justifyContent: 'center' }}>
                                        {postReplyValidationError.error ? (
                                          <div style={{ marginBottom: '20px' }}>
                                            <AlertMessages status="error" message={postReplyValidationError.errorMessage} />
                                          </div>
                                        ) : null}
                                      </Grid>
                                    </Grid>
                                    <TextField
                                      id="title"
                                      autoFocus={true}
                                      label="Add Reply Here!"
                                      helperText="max: 1000 chars"
                                      required
                                      variant="outlined"
                                      size="small"
                                      inputProps={{
                                        maxLength: 1000,
                                      }}
                                      style={{
                                        width: '70%'
                                      }}
                                      onChange={handleChangeReply}
                                    />
                                    {postBtnLoader ? (
                                      <CircularProgress size={20} style={{ marginBottom: '-9px' }} />
                                    ) : null}
                                    <IconButton disabled={postBtnLoader} edge="end" style={{ marginLeft: '20px', borderRadius: '5px', border: '1px solid #999', padding: '5px' }} aria-label="Post reply" onClick={() => { triggerPostComment(data) }}>
                                      <SmsIcon className={classes.replyIcon} /> <div style={{ fontSize: '10px' }}>Post reply</div>
                                    </IconButton>
                                    <IconButton disabled={postBtnLoader} edge="end" style={{ marginLeft: '20px', borderRadius: '5px', border: '1px solid #999', padding: '5px' }} aria-label="cancel" onClick={() => { setResponseId(null) }}>
                                      <CancelIcon className={classes.replyIcon} /> <div style={{ fontSize: '10px' }}>Cancel</div>
                                    </IconButton>
                                  </form>
                                ) : null}
                              </Grid>
                              <div style={{ marginLeft: '40px', marginRight: '10px' }}>
                                {data.id === viewCommentsIndex ? (
                                  <React.Fragment>
                                    {subRepliesLoader ? (
                                      <SubRepliesLoader />
                                    ) : (
                                      renderSubReplies(data)
                                    )}
                                  </React.Fragment>
                                ) : null}
                              </div>
                              <Divider variant="inset" component="li" aria-hidden="hidden" />
                            </React.Fragment>
                          ))}
                        </InfiniteScroll>
                      </List>
                    ) : (
                      <Typography>Responses not yet added!</Typography>
                    )}
                  </React.Fragment>
                )}
              </Grid>
            </React.Fragment>
          ) : (
            <React.Fragment>
              <Grid item xs={11} md={11} lg={11} sm={10} style={{ paddingLeft: '10px' }}>
                <Paper className={classes.gradeWrapper}>
                  {gradeViewLoader ? (
                    <GradeViewLoader />
                  ) : (
                    <React.Fragment>
                      <div id="mainH1Tag" tabIndex="-1" className="accessibility">
                        <p>{`discussion responses count ${studentResponses.reply_count}`}</p>
                      </div>
                      <Tooltip title={`${studentResponses.reply_count && studentResponses.reply_count} responses`} aria-hidden="true">
                        <IconButton style={{ float: 'left' }}>
                          <StyledBadge badgeContent={studentResponses.reply_count && studentResponses.reply_count} color='secondary'>
                            <img src={responseIcon} alt="response count" style={{ height: '24px', marginTop: '11px' }} aria-hidden="true" />
                          </StyledBadge>
                        </IconButton>
                      </Tooltip>
                      <IconButton edge="end" aria-label="Close Grade View" className={classes.closeGradeWrapper} onClick={() => { closeGradeView() }}>
                        <CancelIcon className={classes.replyIcon} /> <div style={{ fontSize: '10px' }}>Close</div>
                      </IconButton>
                      <Typography className={classes.gradeTitle}>
                        {discussionData && discussionData.title && discussionData.title.length > 95 ? (
                          discussionData.title.substr(0, 90) + '...'
                        ) : (
                          discussionData.title
                        )}
                      </Typography>
                      <div className={classes.gradeitemInfo}>
                        Start Date: {discussionData && discussionData.start_date ? dateFormat(discussionData && discussionData.start_date) : "NA"} &nbsp;&nbsp; Due Date: {dateFormat(discussionData && discussionData.end_date)} &nbsp;&nbsp; {discussionData && discussionData.graded_reply && discussionData.points ? (`Pts: ${discussionData.points}`) : null} &nbsp;&nbsp;
                      </div>
                      <Grid container>
                        <Grid item xs={12} md={12} lg={6} sm={6}>
                          <Typography variant="caption" display="block" className={classes.infoBlock}>
                            <p><b>Name:</b></p>
                            <p>{`${studentResponses.first_name ? studentResponses.first_name : ''} ${studentResponses.last_name ? studentResponses.last_name : ''}`}</p>
                          </Typography>
                        </Grid>
                        <Grid item xs={12} md={12} lg={6} sm={6} style={{ marginTop: '20px', marginBottom: '10px' }}>
                          {discussionData && discussionData.graded_reply ? (
                            <React.Fragment>
                              <Grid item xs={12} sm={12} md={12} lg={12} style={{ display: 'flex', justifyContent: 'center' }}>
                                {gradeValidation.error ? (
                                  <div style={{ marginBottom: '20px' }}>
                                    <AlertMessages status="error" message={gradeValidation.errorMessage} />
                                  </div>
                                ) : null}
                              </Grid>
                              <form autoComplete="off" onSubmit={evnt => { evnt.preventDefault() }} >
                                <TextField
                                  id="studentGrade"
                                  label="Points"
                                  type="number"
                                  variant="outlined"
                                  size="small"
                                  required
                                  autoFocus
                                  defaultValue={defaultPoints}
                                  InputLabelProps={{
                                    shrink: true,
                                  }}
                                  inputProps={{
                                    maxLength: 3,
                                  }}
                                  onChange={handleChangeGrade}
                                />
                                {gradeBtnLoader ? (
                                  <CircularProgress size={20} style={{ marginBottom: '-9px', marginLeft: '5px' }} />
                                ) : null}
                                <Button disabled={gradeBtnLoader} style={{ marginLeft: '10px', marginTop: '5px' }} variant="outlined" size="small" color="primary" onClick={(evnt) => { submitStudenGrade(evnt) }}>
                                  {studentResponses && studentResponses.user_score !== null ? 'Update' : 'Submit'}
                                </Button>
                              </form>
                            </React.Fragment>
                          ) : null}
                        </Grid>
                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                          <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <Typography variant="caption" className={classes.infoBlock}>
                              <b>Responses</b>:
                            </Typography>
                            <List>
                              {studentResponses && studentResponses.user_data && studentResponses.user_data.map((userData, index) => (
                                <ListItem key={index}>
                                  <div style={{ display: 'flex', flexDirection: 'column' }}>
                                    <div style={{ textAlign: 'initial', lineBreak: 'anywhere' }} dangerouslySetInnerHTML={createMarkup(userData && userData.reply_data)}></div>
                                    <div className={classes.itemInfo}>
                                      Submitted Date: {userData.submission_date ? dateTimeFormat(userData.submission_date && userData.submission_date) : ''}
                                    </div>
                                    {userData && userData.attachment_details && userData.attachment_details.file_name ? (
                                      <React.Fragment>
                                        <span>
                                          {userData.attachment_details && userData.attachment_details.file_name && userData.attachment_details.file_name.split('.')[1] === 'pdf' ? <PictureAsPdfIcon style={{ color: '#2e8eec', marginBottom: '-5px', fontSize: '19px', marginLeft: '3px', marginRight: '-10px' }} /> : userData.attachment_details.file_name.split('.')[1] === 'ppt' ? <PictureInPictureIcon style={{ color: '#2e8eec', marginBottom: '-5px', fontSize: '19px', marginLeft: '3px', marginRight: '-10px' }} /> : <DescriptionIcon style={{ color: '#2e8eec', marginBottom: '-5px', fontSize: '19px', marginLeft: '3px', marginRight: '-10px' }} />}
                                          <a href={userData.attachment_details && userData.attachment_details.file_url && userData.attachment_details.file_url} target='_blank' style={{ marginLeft: '17px' }}>
                                            {userData.attachment_details && userData.attachment_details.file_name && userData.attachment_details.file_name && userData.attachment_details.file_name}
                                          </a>
                                        </span>
                                      </React.Fragment>
                                    ) : null}
                                  </div>
                                </ListItem>
                              ))}
                            </List>
                          </div>
                          {studentResponses && studentResponses.user_comment_data && studentResponses.user_comment_data.length ? (
                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                              <Typography variant="caption" className={classes.infoBlock}>
                                <b>Comments</b>:
                              </Typography>
                              <List>
                                {studentResponses && studentResponses.user_comment_data && studentResponses.user_comment_data.map((data, index) => (
                                  <ListItem key={index}>
                                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                                      <div className={classes.repliesWrapper}>{` Replied to : ${data.reply_to_first_name ? data.reply_to_first_name : null} ${data.reply_to_last_name ? data.reply_to_last_name : null}`}</div>
                                      <div style={{ marginLeft: '30px' }}>
                                        <div style={{ lineBreak: 'anywhere' }}>{data.comment ? data.comment : null}</div>
                                        <div className={classes.itemInfo}>
                                          Submitted Date: {data.comment_sub_date ? dateTimeFormat(data.comment_sub_date && data.comment_sub_date) : ''}
                                        </div>
                                      </div>
                                    </div>
                                  </ListItem>
                                ))}
                              </List>
                            </div>
                          ) : null}
                        </div>
                      </Grid>
                    </React.Fragment>
                  )}
                </Paper>
              </Grid>
            </React.Fragment>
          )}
        </Grid>
      </Grid>
    </div>
  )
}

const mapStateToProps = state => {
  return {}
}
export default connect(
  mapStateToProps, { showSnackBar }
)(DiscussionReport);